import React, {Component} from 'react';
import environment from 'lib/environment';
import Session from 'lib/session';
import ErrorView from '../components/error-view';

const errorUrl = environment.get().error_url;

// Class
export default class ErrorContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: {},
      errorUrl,
    };
  }

  componentDidMount() {
    // get error from session
    const rawError = JSON.parse(Session.getItem('last_error')) || {};
    this.setState({
      error: {status: rawError.status, data: rawError.data},
    });
  }

  render() {
    return (
      <ErrorView
        errorUrl={this.state.errorUrl}
        error={this.state.error}
      />
    );
  }
}
